import createAssignmentStorePayload from 'garaje/utils/bulk-map-operations/create-assignments';
import createDeskStorePayload from 'garaje/utils/bulk-map-operations/create-desks';
import createFeatureStorePayload from 'garaje/utils/bulk-map-operations/create-features';

export { createDeskStorePayload, createFeatureStorePayload, createAssignmentStorePayload };
